// extracted by mini-css-extract-plugin
export var inner = "mainheader-module--inner--3853f";
export var logo = "mainheader-module--logo--be22d";
export var menu = "mainheader-module--menu--ad81c";
export var search = "mainheader-module--search--2414f";
export var utilities = "mainheader-module--utilities--b81b8";
export var wrap = "mainheader-module--wrap--e65f8";